import { handleActions } from 'redux-actions';

import http from '../../../shared/http';
import createPagination from '../../../shared/new-pagination';

import endpoints from '../../../../config/endpoints';

const namespace = 'popupsPopupList';

const pagination = createPagination({
	namespace,
	initialState: { perPage: 100 }
});

// action types
const FETCH_DATA_SUCCESS = `${namespace}/fetch-data-success`;
const FETCH_MORE_SUCCESS = `${namespace}/fetch-more-success`;
const FETCH_DATA_ERROR = `${namespace}/fetch-data-error`;
const TOGGLE_PROGRESS_BAR = `${namespace}/toggle-progress-bar`;
const REMOVE_POPUP_SUCCESS = `${namespace}/remove-popup-success`;
const REMOVE_POPUP_ERROR = `${namespace}/remove-popup-error`;

// initial state
const initialState = {
	data: null,
	isLoading: true,
	isError: false,
	pagination: pagination.initialState
};

// actions
export const actions = {
	own: {
		fetchData: () => (dispatch, getState) => {
			const page = 1;
			request(getDefaultRequestQuery(page, getState), FETCH_DATA_SUCCESS)(dispatch)
				.then((action) => {
					if (action.type === FETCH_DATA_SUCCESS) {
						dispatch(pagination.actions.update({
							page,
							total: action.payload.data.total
						}));
					}
				});
		},
		fetchMore: () => (dispatch, getState) => {
			const page = getState()[namespace].pagination.currentPage + 1;
			request(getDefaultRequestQuery(page, getState), FETCH_MORE_SUCCESS)(dispatch)
				.then((action) => {
					if (action.type === FETCH_MORE_SUCCESS) {
						dispatch(pagination.actions.update({
							page,
							total: action.payload.data.total
						}));
					}
				});
		},
		toggleProgressBar: () => ({ type: TOGGLE_PROGRESS_BAR }),
		removePopupById: id => (dispatch, getState) => {
			const isConfirmed = confirm('Are you sure you want to DELETE this popup?');

			if (isConfirmed) {
				const request = http({
					url: `${endpoints.CUSTOM_POPUPS.BASE}/${id}`,
					method: 'delete',
					actions: [REMOVE_POPUP_SUCCESS, REMOVE_POPUP_ERROR]
				});

				request(dispatch).then(() => actions.own.fetchData()(dispatch, getState));
			}
		}
	},
	pagination: {
		showMore: () => (dispatch, getState) => {
			dispatch(actions.own.toggleProgressBar());
			dispatch(actions.own.fetchMore());
		}
	}
};

const reducers = Object.assign(
	{
		[FETCH_DATA_SUCCESS]: (state, action) => ({
			...state,
			data: action.payload.data.rows,
			isLoading: false,
			isError: false
		}),
		[FETCH_MORE_SUCCESS]: (state, action) => ({
			...state,
			data: state.data.concat(action.payload.data.rows),
			isLoading: false,
			isError: false
		}),
		[FETCH_DATA_ERROR]: (state, action) => ({
			...state,
			isLoading: false,
			isError: true
		}),
		[TOGGLE_PROGRESS_BAR]: (state, action) => ({
			...state,
			isLoading: !state.isLoading
		})
	},
	pagination.reducers
);

export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	select: (state, field) => state[namespace][field],
	getPagination: pagination.selectors.getPagination
};

function getDefaultRequestQuery(page, getState) {
	const state = getState()[namespace];

	const limit = state.pagination.perPage;

	return {
		offset: (page - 1) * limit,
		limit
	};
}

function request(query, successActionType) {
	return http({
		url: endpoints.CUSTOM_POPUPS.BASE,
		method: 'get',
		actions: [successActionType, FETCH_DATA_ERROR],
		query
	});
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/popups/popup/list/index.js